import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageIntro from '@/components/feature/PageIntro';
import CTASection from '@/components/feature/CTASection';
import { industryDetails } from '@/mocks/pages';

export default function IndustriesPage() {
  return (
    <>
      <Navbar />
      <main className="bg-background-50 pt-16 md:pt-20">
        <PageIntro crumb="Industries" eyebrow="Industries We Serve" title="BUILT FOR THE SYSTEMS THAT MATTER." docTitle="Industries | NORTHLINE Flow Systems">
          <p>Valves and flow-control components for manufacturing, energy, water and process applications.</p>
        </PageIntro>

        <section className="max-w-[1200px] mx-auto px-5 md:px-10 pb-12 md:pb-16">
          {industryDetails.map((ind, i) => (
            <article key={ind.name} className="group grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center pb-16 md:pb-24">
              <div className={`lg:col-span-7 ${i % 2 ? 'lg:order-2' : ''}`}>
                <div data-mo="image" className="w-full h-[240px] sm:h-[340px] lg:h-[440px] rounded-lg overflow-hidden bg-background-100">
                  <img src={ind.image} alt={`${ind.name} facility - NORTHLINE industrial valves`} title={`${ind.name} - NORTHLINE`} className="w-full h-full object-cover object-top transition-transform duration-[600ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.02]" />
                </div>
              </div>
              <div className="lg:col-span-5">
                <span className="font-label text-xs text-primary-500">0{i + 1}</span>
                <h2 data-mo="title" className="mt-4 font-heading text-3xl md:text-4xl tracking-[-0.02em] text-foreground-950">{ind.name}</h2>
                <p className="mt-4 t-body text-foreground-600 max-w-md">{ind.body}</p>
                <ul className="mt-6 flex flex-wrap gap-2">
                  {ind.families.map((f) => (
                    <li key={f}>
                      <Link to={`/products?category=${encodeURIComponent(f)}`} className="inline-block px-3 py-1.5 rounded-full border border-background-300 text-xs text-foreground-700 hover:border-primary-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">{f}</Link>
                    </li>
                  ))}
                </ul>
                <div className="mt-8 flex flex-wrap gap-6 font-label text-[11px] tracking-[0.12em] uppercase">
                  <Link to={`/products?category=${encodeURIComponent(ind.category)}`} className="text-foreground-950 hover:text-primary-500 cursor-pointer whitespace-nowrap">View products <i className="ri-arrow-right-line" /></Link>
                  <Link to="/request-quote" className="text-primary-500 hover:text-primary-700 cursor-pointer whitespace-nowrap">Request a quote <i className="ri-arrow-right-line" /></Link>
                </div>
              </div>
            </article>
          ))}
        </section>

        <CTASection title="COMPONENTS FOR COMPLEX REQUIREMENTS." body="Browse the catalog or share your line requirements with our team." secondary={{ label: 'Product Catalog', to: '/products' }} />
      </main>
      <Footer />
    </>
  );
}